export enum ModelFormModeEnum {
  CREATE,
  EDIT_FROM_DEFAULT_CONFIG,
  EDIT_FROM_VERSION_CONFIG,
}

// TODO: replace with a more strict type, eg: string | Record<...> | null | undefined
export type FieldValueMapType<T = unknown> = { [key: string]: T };

export interface FormikInitialValues {
  advancedFields: CF.API.Models.ModelTypeFieldsEntity[];
  appDatasets: CF.API.Datasets.Dataset[];
  basicFields: CF.API.Models.ModelTypeFieldsEntity[];
  errorDescription?: string;
  errorDetails?: string;
  errorString: string;
  fieldValueMap: FieldValueMapType;
  isCreatable: boolean;
  isModelIdSubmitted: boolean;
  isSaving: boolean;
  isTrainable: boolean;
  mode: ModelFormModeEnum;
  model?: CF.API.Models.Model;
  modelId: string;
  modelTitle: string;
  modelType: string;
  modelTypeDescription: string;
  deployment?: string;
  deploymentData?: CF.API.Compute.Deployment;
  totalInputCount: string;
  trainingTemplateFields: CF.API.Models.ModelTypeEnumOptionsEntity[];
  trainingTimeEstimate: string;
}
